import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import estilos from '../../UsuarioInspectorEnCampo/Asociados/Tabs/TabsInspeccionarComponent.module.css'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import SolicitudesComponent from './SolicitudesComponent'
import SolicitudesFC09Component from './SolicitudesFC09Component'

import { useDispatch, useSelector } from 'react-redux'
import { obtenerTodasLasSolicitudesWithStatusEnviado } from '../../../redux/AtencionAClienteDucks'

function TabsSolicitudesComponent(props) {

    const dispatch = useDispatch()

    const [tabUno, setTabUno] = React.useState(true)
    const [tabDos, setTabDos] = React.useState(false)
    const [tabTres, setTabTres] = React.useState(false)
    const [tabCuatro, setTabCuatro] = React.useState(false)
    const [tabCinco, setTabCinco] = React.useState(false)
    const [tabSeis, setTabSeis] = React.useState(false)
    const [tabSiete, setTabSiete] = React.useState(false)
    const [tabOcho, setTabOcho] = React.useState(false)
    const [tabNueve, setTabNueve] = React.useState(false)
    const [tabDiez, setTabDiez] = React.useState(false)

    const [solicitudes, setSolicitudes] = React.useState([])

    const setearValores = (tabNumber) => {
        setTabUno(tabNumber === 1);
        setTabDos(tabNumber === 2);
        setTabTres(tabNumber === 3);
        setTabCuatro(tabNumber === 4);
        setTabCinco(tabNumber === 5);
        setTabSeis(tabNumber === 6);
        setTabSiete(tabNumber === 7);
        setTabOcho(tabNumber === 8);
        setTabNueve(tabNumber === 9);
        setTabDiez(tabNumber === 10);
    }

    React.useEffect(() => {
        dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 })).then((res) => {
            console.log(res.data.data)
            setSolicitudes(res.data.data)
        })
    }, [])

    return (
        <Fragment>
            <div className={`row text-center ${estilos.tabsCuartoNivel} `}>
                {/**OPCIONES NIVEL 3 */}
                <div className='col'>
                    <button onClick={() => setearValores(1)} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabUno ? '#68813B' : 'transparent', color: tabUno ? 'white' : 'black' }}>FC-01</button>
                </div>
                <div className='col'>
                    <button onClick={() => setearValores(2)} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabDos ? '#68813B' : 'transparent', color: tabDos ? 'white' : 'black' }}>FC-09</button>
                </div>
                <div className='col'>
                    <button onClick={() => setearValores(3)} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabTres ? '#68813B' : 'transparent', color: tabTres ? 'white' : 'black' }}>FC-33</button>
                </div>
                <div className='col'>
                    <button onClick={() => setearValores(4)} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabCuatro ? '#68813B' : 'transparent', color: tabCuatro ? 'white' : 'black' }} disabled>FC-31</button>
                </div>
                <div className='col'>
                    <button onClick={() => setearValores(5)} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabCinco ? '#68813B' : 'transparent', color: tabCinco ? 'white' : 'black' }} disabled>FC-34</button>
                </div>
                <div className='col'>
                    <button onClick={() => setearValores(6)} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabSeis ? '#68813B' : 'transparent', color: tabSeis ? 'white' : 'black' }} disabled>FC-35</button>
                </div>
                <div className='col'>
                    <button onClick={() => setearValores(7)} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabSiete ? '#68813B' : 'transparent', color: tabSiete ? 'white' : 'black' }} disabled>FC-36</button>
                </div>
                <div className='col'>
                    <button onClick={() => setearValores(8)} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabOcho ? '#68813B' : 'transparent', color: tabOcho ? 'white' : 'black' }} disabled>FC-41</button>
                </div>
            </div>

            {
                tabUno ? (
                    <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                        <div className="col ">
                            <SolicitudesComponent />
                        </div>
                    </div>
                ) :
                    tabDos ? (
                        <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                            <SolicitudesFC09Component solicitudes={solicitudes.fc_09_solicitudemicioncertificadonomexportacionyentregahologram} tipo={9} />
                        </div>
                    ) :
                        tabTres ? (
                            <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                <SolicitudesFC09Component solicitudes={solicitudes.fc_33_solicitudenvasadonacional} tipo={30} />
                            </div>
                        ) :
                            tabCuatro ? (
                                <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                    <SolicitudesFC09Component solicitudes={solicitudes.fc_31_solicitudseguimiento} tipo={31} />
                                </div>
                            ) :
                                tabCinco ? (
                                    <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                        <SolicitudesFC09Component solicitudes={solicitudes.fc_34_notificacionsuspencionyreactivacion} tipo={34} />
                                    </div>
                                ) :
                                    tabSeis ? (
                                        <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                            <SolicitudesFC09Component solicitudes={solicitudes.fc_35_notificaciondeserviciosvarios} tipo={35} />
                                        </div>
                                    ) :
                                        tabSiete ? (
                                            <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                                <SolicitudesFC09Component solicitudes={solicitudes.fc_36_solicituddeactualizacion} tipo={36} />
                                            </div>
                                        ) :
                                            tabOcho ? (
                                                <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                                    <SolicitudesFC09Component solicitudes={solicitudes.fc_41_solicitudparabebidasconmezcal} tipo={41} />
                                                </div>
                                            ) :
                                                (<></>)
            }

        </Fragment>
    );
};


export default withRouter(TabsSolicitudesComponent)
